import { Building, CheckCircle2 } from "lucide-react";

const FacilityManagement = () => {
  const services = [
    "Daily maintenance and housekeeping",
    "Preventive maintenance programs",
    "24/7 security and access control",
    "Landscaping and garden maintenance",
    "Waste management and recycling",
    "Common area cleaning and upkeep",
  ];

  return (
    <section id="facility" className="py-20 sm:py-28 bg-gradient-to-b from-slate-50 to-white">
      <div className="section-container">
        <h2 className="section-title">Facility Management</h2>
        <p className="section-subtitle">
          Professional services ensuring community excellence
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* FM Agency Info */}
          <div>
            <div className="bg-gradient-to-br from-blue-50 to-slate-50 border border-blue-200 rounded-lg p-8 mb-8">
              <div className="flex items-start gap-4 mb-4">
                <div className="p-3 bg-blue-600 rounded-lg">
                  <Building className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-blue-600 uppercase tracking-wide">
                    Facility Management Agency
                  </p>
                  <p className="text-2xl font-bold text-foreground mt-1">
                    GoIntegra Facility Management Services
                  </p>
                </div>
              </div>
              <p className="text-muted-foreground">
                Professional management ensuring optimal community operations and resident satisfaction.
              </p>
            </div>
          </div>

          {/* Services List */}
          <div>
            <h3 className="text-2xl font-bold text-foreground mb-6">
              Services & Support
            </h3>
            <div className="space-y-3">
              {services.map((service, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                  <span className="text-foreground font-medium">{service}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FacilityManagement;
